module.exports = __webpack_public_path__ + "img/icon1.262cb975.png";